import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export { useBreakpoint };
